<template>
  <div>
    <div style="max-width: 1200px; margin: 0 auto;">
      <div class="bd-y pd-y-20">
        <div class="container">
          <div class="d-flex">
            <h3 class="mg-b-0">{{ task.obj.task }}</h3>
            <span class=" text-muted mg-l-auto">{{
              task.obj.createdDate | moment("LLLL")
            }}</span>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-8 col-xl-9">
            <div v-html="task.obj.taskDesc"></div>
          </div>
          <div class="col-xs-12 col-lg-4 col-xl-3">
            <h4 class="pd-l-xs-20">{{ comp.locType1Name }}</h4>
            <ul class="list-group">
              <li
                v-for="(t, i) in tasks"
                :key="i"
                class="list-group-item d-flex align-items-center bd-l-0 bd-r-0 bd-t-0 bd-b"
                :class="{ active: t.id == $route.params.cid }"
              >
                <router-link
                  :to="{
                    name: $store.state.app.activeGroup.publicPage.route,
                    params: {
                      id: $store.state.app.contentPageId,
                      cid: t.id
                    }
                  }"
                >
                  <img
                    :src="`${t.defaultAttachmentUrl}?w=60&h=55&mode=crop`"
                    class="wd-60 mg-r-10"
                    alt=""
                  />
                </router-link>
                <router-link
                  :to="{
                    name: $store.state.app.activeGroup.publicPage.route,
                    params: {
                      id: $store.state.app.contentPageId,
                      cid: t.id
                    }
                  }"
                >
                  <div>
                    <h6
                      class="tx-13 tx-inverse tx-semibold"
                      :class="{ 'text-white': t.id == $route.params.cid }"
                    >
                      {{ t.task }}
                    </h6>
                    <span class="d-block tx-11 text-muted">{{
                      t.createdDate | moment("YYYY.MM.DD HH:mm")
                    }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      task: {
        obj: {},
        rdy: false
      },
      tasks: []
    };
  },
  mounted() {
    this.init();
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    init() {
      this.loadTask(this.$route.params.cid);
    },
    loadTask(id) {
      request({
        api: { method: "GET", url: "task/TaskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.task.obj = res.data.task;
          this.task.rdy = true;
        }
      });
    },
    loadTasks(cid) {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 10,
          ot: 357,
          model: { isPublic: true, locTypeId1: cid }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
    }
  }
};
</script>

<style></style>
